import React, { Fragment } from "react";
import { t } from "@lingui/macro";
import { I18n } from "@lingui/react";
import { I18n as I18nInterface } from "@lingui/core";
import { FieldText } from "@conserveit/blocks";
import { MsgAlert } from "..";
import { Hr } from "./UserForm.styles";

interface ErrorMessages {
  [key: string]: string;
}

const validationErrorMessages = (i18n: I18nInterface): ErrorMessages => ({
  currentPassword: i18n._(
    t(
      "change_password_modal_data.current_password_error_message"
    )`Current password is required.`
  ),
  newPassword: i18n._(
    t(
      "change_password_modal_data.new_password_error_message"
    )`New Password is required.`
  ),
  confirmNewPassword: i18n._(
    t(
      "change_password_modal_data.confirm_new_password_error_message"
    )`Confirm New Password is required.`
  ),
  passwordMismatch: i18n._(
    t(
      "change_password_modal_data.password_mismatch"
    )`New Password and Confirm New Password do not match. Try re-entering both.`
  ),
});

export const parseErrorMessage = (
  error: string[] = [],
  i18n: I18nInterface
) => {
  const definedErrorMessages = validationErrorMessages(i18n);
  return error.reduce(
    (message, err) =>
      Object.keys(definedErrorMessages).includes(err)
        ? `${message}\n\n${definedErrorMessages[err]}`
        : `${message}\n\n${err}`,
    ""
  );
};

interface Props {
  error: [];
  formData: {
    [key: string]: any;
  };
  onChange: () => void;
}
const ChangePasswordForm: React.FC<Props> = ({ error, formData, onChange }) => (
  <I18n>
    {({ i18n }) => (
      <Fragment>
        {error && (
          <MsgAlert type="error" message={parseErrorMessage(error, i18n)} />
        )}
        <FieldText
          name="current_user_password"
          type="password"
          label={i18n._(
            t("change_password.current_password")`Current Password`
          )}
          placeholder={i18n._(
            t("change_password.current_password")`Current Password`
          )}
          value={formData.current_user_password || ""}
          onChange={onChange}
        />

        <Hr />

        <FieldText
          name="new_user_password"
          type="password"
          placeholder={i18n._(t("change_password.new_password")`New Password`)}
          label={i18n._(t("change_password.new_password")`New Password`)}
          value={formData.new_user_password || ""}
          onChange={onChange}
        />

        <FieldText
          name="new_user_password_confirm"
          type="password"
          label={i18n._(
            t(
              "change_password.confirm_new_password_placeholder"
            )`New Password (again)`
          )}
          placeholder={i18n._(
            t(
              "change_password.confirm_new_password_placeholder"
            )`New Password (again)`
          )}
          value={formData.new_user_password_confirm || ""}
          onChange={onChange}
        />
      </Fragment>
    )}
  </I18n>
);

export default ChangePasswordForm;
